jQuery(document).ready(function($) {

	// // interval animations
	// // wait until FontAWesome loaded
	// $(window).load(() => {
	// 	const intervalAnimations = document.querySelectorAll('.animate-interval');
	// 	console.log(intervalAnimations);
	// 	if (intervalAnimations) {
	// 			intervalAnimations.forEach((intervalAnimation) => {
	// 				intervalAnimation.classList.add('active');
	// 				setTimeout(() => {
	// 					intervalAnimation.classList.remove('active');
	// 				}, 1000);
	// 				setInterval(() => {
	// 					console.log(intervalAnimation);
	// 					intervalAnimation.classList.add('active');
	// 					setTimeout(() => {
	// 						intervalAnimation.classList.remove('active');
	// 					}, 1000);
	// 				}, 5000);
	// 			});
	// 	}
	// });

	// onhover animations
	const onhoverAnimations = document.querySelectorAll('.onhover');
	if (onhoverAnimations) {
		onhoverAnimations.forEach((hoverAnimation) => {
			hoverAnimation.addEventListener('mouseover', () => {
				hoverAnimation.classList.add('active');
			});
			hoverAnimation.addEventListener('mouseout', () => {
				setTimeout(() => {
					hoverAnimation.classList.remove('active');
				}, 1000);
			});
		});
	}

	// onscroll animations
	const onscrollAnimations = document.querySelectorAll('.onscroll');
	if (onscrollAnimations) {
		// get animation classes for the elements
		onscrollAnimations.forEach((animationElement) => {
		// 		if (membershipPartners) {
		// membershipPartners.forEach((membershipPartner) => {
		  var observer = new IntersectionObserver((entries) => {
        animationObserverCallback(entries, observer, animationElement);
			}, 
			{ threshold: 0 });
			observer.observe(animationElement);
		});
	}
	let animationDelay = 500;

	const animationObserverCallback = (entries, observer, element) => {
		entries.forEach((entry, animatingElement) => {
			if (entry.isIntersecting) {
				setTimeout(() => {
					entry.target.classList.add('active');
				}, animationDelay);
			}
		});
	};

});